import { createStore } from '@stencil/store';

const initialState = {
  dealerId: 0,
  dealerGuid: '',
  cobrandingGroupId: '',
  dealerName: '',
  acceptsReplacementVehicleAnswers: true,
  isRequirePhoto: false,
  isRequireVinPlate: false,
  replacementVehicleMakes: [],
  replacementVehicleModels: [],
  replacementVehicleTypes: [],
  internalGroupID: 0,
  imageUrl: '',
  enabled: true,
  cobrandingMeasurementId: '',
};

const { on, onChange, state, reset } = createStore(initialState);

export { on, onChange, state, reset };
export default state;
